import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowBackOutline } from '@lyearn/icons';
import { LinkButton, Stack, Typography } from '@lyearn/ui';

import { HeaderProps } from '../types';

const Header: React.FC<HeaderProps> = (props) => {
  const { hideOverlay } = props;

  const { t } = useTranslation();

  return (
    <Stack alignItems="center" className="h-48 w-full flex-shrink-0 bg-bg-secondary px-16">
      <LinkButton onClick={hideOverlay}>
        <ArrowBackOutline className="h-20 w-20 cursor-pointer text-link-internal me-8 hover:text-icon-active rtl:rotate-180" />
      </LinkButton>
      <Typography color="text-text-primary" variant="heading-xxs">
        {t('Common:Design.Cover')}
      </Typography>
    </Stack>
  );
};

export default Header;
